module.exports = __webpack_public_path__ + "static/media/icon_mail.079ac723.svg";